import React from 'react'

function BoardMultiBFV() {
    return (
        <embed src="\pdfs\EZ1.2.6_BF-V_Broad_multiplex_outlet_01.2012-1-ACCESSORY_kr.pdf" width="100%" height="2100px" />
    )
}

export default BoardMultiBFV